import Residents from '../ui/Residents';
import { connect } from 'react-redux';
import {
  residentsSubmit,
  residentFormSubmit,
  skipSubmit,
  goBack,
  invalidateResidents,
  fetchResidentsIfNeeded,
  photoFormSubmit,
  certificateFormSubmit,
  policeVettingFormSubmit
 } from '../../actions';

const mapStateToProps = (state, props) => {
  const householdVaccination = state => {
    const publicElements =  state.profileElements.filter(profile => (profile.kind === 'public'))
        
    if (publicElements.length === 0 || !publicElements[0].answers) return ''

    return publicElements[0].answers.household_fully_vaccinated
  }

  return ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    residents: state.residents,
    requiredFields: state.requiredFields,
    territory: state.territory,
    vaccinationMandatory: state.vaccinationMandatory,
    householdVaccination: householdVaccination(state),
    residentVaccinationOptions: state.residentVaccinationOptions,
    uploader: state.uploader
  })
}

const mapDispatchToProps = dispatch =>
  ({
    onResidentsSubmit(payload) {
       dispatch(
         residentsSubmit(payload)
       );
    },
    onPhotoFormSubmit(payload) {
      dispatch(invalidateResidents())
      dispatch(
        photoFormSubmit(payload)
      )
    },
    onPhotoDestroySubmit(payload) {
      dispatch(invalidateResidents())
      dispatch(
        photoFormSubmit(payload)
      )
    },
    onCertificateFormSubmit(payload) {
      dispatch(invalidateResidents())
      dispatch(
        certificateFormSubmit(payload)
      )
    },
    onPoliceVettingFormSubmit(payload) {
      dispatch(invalidateResidents())
      dispatch(policeVettingFormSubmit(payload))
    },
    onResidentFormSubmit(payload) {
       dispatch(invalidateResidents());
       dispatch(
         residentFormSubmit(payload)
       );
    },
    onSkipSubmit(payload) {
       dispatch(
         skipSubmit(payload)
       );
    },
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       );
    },
    onFetchResidentsIfNeeded(payload) {
      dispatch(fetchResidentsIfNeeded());
    },
    onResidentsRefresh(payload) {
      dispatch(invalidateResidents());
      dispatch(fetchResidentsIfNeeded());
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Residents);

export default Container;
